import angular from 'angular'
import './angAccordion.js'

require('angular-loading-bar/build/loading-bar.min.js')

import 'md-steppers'

import deletedPage from '../deleted-page/deletedPage.html'

export default angular.module('job', ['ui.router', 'md-steppers'])
  .filter('numKeys', function () {
    return function (json) {
      console.log(json)
      var keys = Object.keys(json)
      return keys.length
    }
  })
  .filter('trim', function () {
    return function (value) {
      if (!angular.isString(value)) {
        return value
      }
      return value.replace(/^\s+|\s+$/g, '')
    }
  })
  .filter('noAccepts', function () {
    return function (items, name) {
      var noAccepts = []
      angular.forEach(items, function (item) {
        if (name === undefined || name === '') {
          noAccepts.push(item)
        } else if (item.name_key !== name) {
          noAccepts.push(item)
        }
      })
      return noAccepts
    }
  })
  .config(function ($stateProvider) {
    'ngInject'

    $stateProvider.state('app.jobs', {
      url: '/jobs' // This path is kept, so whenever it is routed to, we can redirect to the correct path (web-react)
    })
    .state('app.jobCreate', {
      url: '/jobs/create', // This path is kept, so whenever it is routed to, we can redirect to the correct path (web-react)
      params: { crewForHire: false, directlyInvitedWorkers: [] }
    })
    .state('app.shift', {
      url: '/job/:jobId/shift/:shiftId?repost',
      views: {
        content: {
          template: deletedPage,
        },
      }
    })
    .state('app.pipeline', {
      url: '/pipeline',
      views: {
        content: {
          template: deletedPage,
        },
      }
    })
    .state('app.pipelineCreate', {
      url: '/pipeline/create/:pipelineId',
      views: {
        content: {
          template: deletedPage,
        },
      }
    })
    .state('app.pipelineAdminCreate', {
      url: '/pipeline/adminCreate/:pipelineId',
      params: { companyId: null },
      views: {
        content: {
          template: deletedPage,
        },
      }
    })
    .state('app.campaign', {
      url: '/pipeline/:pipelineId',
    })
    .state('app.pipelineAdmin', {
      url: '/pipeline/admin/',
      views: {
        content: {
          template: deletedPage,
        },
      }
    })
    .state('app.interview', {
      url: '/job/:jobId',
      views: {
        content: {
          template: deletedPage,
        },
      }
    })
  })
